export default {
  name: 'ShAgentAvatar',

  props: {
    avatar: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '60px',
    },
  },
};
